"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const stages = [{
  num: "01",
  title: "Real-Time Coordination",
  desc: "Daily coordination of teams and resources\xA0\xA0\nKeeping operations running without delays"
}, {
  num: "02",
  title: "Safety & Compliance",
  desc: "Monitoring of HSE standards\xA0\xA0\nFull adherence to local regulations"
}, {
  num: "03",
  title: "Quality Assurance",
  desc: "On-site inspections\xA0\xA0\nEnsuring work meets required standards"
}, {
  num: "04",
  title: "Logistical Support",
  desc: "Equipment and personnel handling\xA0\xA0\nSupporting large-scale site operations"
}];
export default function TheConstructionJourney() {
  return;
}